<template>
	<div class="mm-page-main" v-loading="loading">
		<div v-for="(data,index) in datas" :key="index">
			<div class="page-header">
				<div v-if="data.either == 0" class="page-title">指示人資料</div>
				<div v-else-if="data.either == 1" class="page-title">兌換人資料</div>
			</div>
			<div class="pagemain">
				<div class="form-group">
					<div class="form-group-content">
						<div class="mm-row">
							<div class="mm-col">
								<div class="mm-item mb20">
									<label class="mm-label">會員類別：</label>
									<el-radio-group disabled v-model="data.type">
										<el-radio-button  label="0">個人</el-radio-button>
										<el-radio-button  label="1">企業</el-radio-button>
										<el-radio-button  label="2">行家</el-radio-button>
									</el-radio-group>
								</div>
							</div>
						</div>
						<div v-if="data.type == 0"><person :data="data" :createinfo="false"></person></div>
						<div v-if="data.type == 1"><company :data="data" :createinfo="false"></company></div>
						<div v-if="data.type == 2"><connoisseur :data="data" :createinfo="false"></connoisseur></div>
					</div>
				</div>
				
			</div>
		</div>
		
	</div>
</template>

<script>
	import person from "@/components/PersonInfo.vue";
	import company from "@/components/CompanyInfo.vue";
	import connoisseur from "@/components/ConnoisseurInfo.vue";
	export default {
		components: {
			person,
			company,
			connoisseur
		},
		props:['order_id'],
		data() {
			return {
				loading: true,	
				clientpage:'person',
				datas:[]
			};
		},
		methods: {
			
			getdata() {
				
				this.post('/api/order/customerinfo', {
					order_id: this.order_id,
				}).then((res) => {
					// console.log(res);	
					this.datas = res;
					this.loading = false;
				}).catch((err) => {
			
					console.log(err)
				})
			}
		},
		created() {
			
			this.getdata();
		}

	};
</script>
<style scoped>
	


	

	

	
</style>
